import { render, staticRenderFns } from "./DraggableImage.vue?vue&type=template&id=11c659c2&"
import script from "./DraggableImage.vue?vue&type=script&lang=js&"
export * from "./DraggableImage.vue?vue&type=script&lang=js&"
import style0 from "./DraggableImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports